import { createApp } from 'vue'
import { createPinia } from 'pinia';
import VueCookie from 'vue-cookies';
// import VueViewer from 'v-viewer'
import VueLazyLoad from 'vue3-lazyload'
// import 'viewerjs/dist/viewer.css'
// /* Import jQuery */
// import $ from "jquery";
//import jQuery from "jquery";
//Object.assign(window, { $: jQuery, jQuery });
// window.$ = $;
// window.jQuery = $;
// import 'jquery-ui';
// import 'jquery-ui-bundle';
// import 'jquery-ui-bundle/jquery-ui.css';


/* Load Main App Vue */

import App from './App.vue';
window.mainApp = createApp(App);
window.DevMgr = window.mainApp
  .use(VueCookie)
  // .use(VueViewer)
  .use(VueLazyLoad, {
    loading: './imgs/Spinner-2.gif'
  })
  .use(createPinia())
  .mount('#_FFFFFFFFFFFFFF00001653153259024829_');
